import React from 'react';

const ServicesSection = () => {
  return (
    <div id="services">
      <div className="container">
        <div className="services-slider swiper" data-aos="fade-up" data-aos-delay="100">
          <div className="swiper-wrapper">
            <div className="swiper-slide">
              <div className="services-block">
                <i className="bi bi-pencil"></i>
                <span>UI DESIGN</span>
                <p className="separator">Designing Intuitive Product Interfaces</p>
              </div>
            </div>
            <div className="swiper-slide">
              <div className="services-block">
                <i className="bi bi-palette"></i>
                <span>BRAND IDENTITY</span>
                <p className="separator">Strategic Visual Identity Systems</p>
              </div>
            </div>
            <div className="swiper-slide">
              <div className="services-block">
                <i className="bi bi-globe"></i>
                <span>WEB DESIGN</span>
                <p className="separator">Responsive Web Applications</p>
              </div>
            </div>
            <div className="swiper-slide">
              <div className="services-block">
                <i className="bi bi-tablet"></i>
                <span>APP DESIGN</span>
                <p className="separator">Mobile-First Product Design</p>
              </div>
            </div>
            <div className="swiper-slide">
              <div className="services-block">
                <i className="bi bi-bar-chart-steps"></i>
                <span>Analytics</span>
                <p className="separator">Data-Driven Decision Making</p>
              </div>
            </div>
            <div className="swiper-slide">
              <div className="services-block">
                <i className="bi bi-person-lines-fill"></i>
                <span>User Research</span>
                <p className="separator">Evidence-Based User Insights</p>
              </div>
            </div>
            <div className="swiper-slide">
              <div className="services-block">
                <i className="bi bi-clipboard"></i>
                <span>User Testing</span>
                <p className="separator">Usability Testing & Validation</p>
              </div>
            </div>
            <div className="swiper-slide">
              <div className="services-block">
                <i className="bi bi-columns"></i>
                <span>Wireframing</span>
                <p className="separator">Information Architecture & Flow</p>
              </div>
            </div>
            <div className="swiper-slide">
              <div className="services-block">
                <i className="bi bi-screwdriver"></i>
                <span>Prototyping</span>
                <p className="separator">Interactive High-Fidelity Prototypes</p>
              </div>
            </div>
            <div className="swiper-slide">
              <div className="services-block">
                <i className="bi bi-person-wheelchair"></i>
                <span>Accessibility Testing</span>
                <p className="separator">Inclusive Design for All</p>
              </div>
            </div>
            <div className="swiper-slide">
              <div className="services-block">
                <i className="bi bi-code-slash"></i>
                <span>Frontend Development</span>
                <p className="separator">Production-Ready Implementation</p>
              </div>
            </div>
          </div>
          <div className="swiper-pagination"></div>
        </div>
      </div>
    </div>
  );
};

export default ServicesSection;
